var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2332_1679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 1.125V25.875M20.25 5.625H10.875C9.71468 5.625 8.60188 6.03984 7.78141 6.77827C6.96094 7.51669 6.5 8.51821 6.5 9.5625C6.5 10.6068 6.96094 11.6083 7.78141 12.3467C8.60188 13.0852 9.71468 13.5 10.875 13.5H17.125C18.2853 13.5 19.3981 13.9148 20.2186 14.6533C21.0391 15.3917 21.5 16.3932 21.5 17.4375C21.5 18.4818 21.0391 19.4833 20.2186 20.2217C19.3981 20.9602 18.2853 21.375 17.125 21.375H6.5",
    stroke: "#00067E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2332_1679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 27,
    fill: "white",
    transform: "translate(-1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSign);
export default __webpack_public_path__ + "static/media/dollar-sign.5c964904b69b98fb0f3f93bb5685c4b2.svg";
export { ForwardRef as ReactComponent };